import React, { FC } from 'react';
import { BennyPeeping as Organism } from '@components/Molecules';

export const BennyPeeping = ({ display, link, image, position }) => {
  return <Organism display={display} image={image} position={position} link={link} />;
};
